/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import jwt_decode from 'jwt-decode';
export const useRegisterToken = () => {
  const urlParams = new URLSearchParams(window.location.search);
  let token = urlParams.get('token');
  let decodedToken: any = {};

  if (token) {
    token = String(token).trim();
    decodedToken = jwt_decode(token);
    console.log(`decodedToken :`, decodedToken);
  }
  return {
    token,
    decodedToken,
  };
};
